module.exports = __webpack_public_path__ + "static/media/breed_standard.e79ae15d.csv";